var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArgenCoIconCloverRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 436.5 425.2",
    style: {
      enableBackground: "new 0 0 436.5 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0clover{fill:#145459;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0clover",
    d: "M213.7,239.9c-5.7-9.4-12.7-16.9-20.8-23c-2.8-2.1-2.8-6.3,0.1-8.4c8.1-6,15.1-13.6,20.8-23 c2.1-3.4,7-3.4,9.1,0c5.7,9.3,12.7,16.9,20.7,22.9c2.8,2.1,2.8,6.3,0,8.4c-8.1,6-15.1,13.6-20.8,23 C220.7,243.3,215.8,243.3,213.7,239.9 M399.4,216.9c-2.8-2.1-2.8-6.3,0-8.4c22.8-16.9,37.1-46.1,37.1-94C436.5,24.3,385,0,321.5,0 c-42,0-78.7,10.5-98.8,43.7c-2.1,3.4-7,3.4-9.1,0C193.6,10.6,156.9,0,115,0C51.5,0,0,23.9,0,114.5c0,47.7,14.3,76.9,37.1,93.9 c2.8,2.1,2.8,6.3,0,8.4C14.3,233.8,0,263,0,310.7c0,90.6,51.5,114.5,115,114.5c42,0,78.7-10.3,98.8-43.5c2.1-3.4,7-3.4,9.1,0 c20.1,33.1,56.8,43.5,98.7,43.5c63.5,0,115-23.6,115-114.5C436.5,263.2,422.2,234,399.4,216.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgenCoIconCloverRgb);
export default __webpack_public_path__ + "static/media/ArgenCo_icon_clover_rgb.e95b5ec171574b899666e44f4ab57b67.svg";
export { ForwardRef as ReactComponent };